<h5
  class="h5"
  mat-dialog-title>
  qa-psql token
</h5>

<mat-dialog-content>
  <mat-form-field class="token-field">
    <mat-label>Token</mat-label>
    <input
      matInput
      [value]="token"
      readonly />
  </mat-form-field>

  <p class="warning">
    Token is shown only now. Open the terminal, run <code>qa-psql login</code> (for stage: <code>qa-psql --stage login</code>) and paste it. Do not share the token and do not paste it in chat.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button
    variant="stroked"
    color="neutral"
    (click)="copy()">
    <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
    {{ copied() ? 'Copied' : 'Copy' }}
  </app-button>
  <app-button mat-dialog-close>Close</app-button>
</mat-dialog-actions>
